<section
  class="target-route-loading-step"
  [attr.aria-busy]="!errorMessage"
  [attr.role]="errorMessage ? 'alert' : 'status'">
  @if (errorMessage) {
    <div class="target-route-error">
      <h1>Unable to load this step</h1>
      <p>{{ errorMessage }}</p>
      <div class="error-actions">
        <button type="button" class="primary-button" (click)="retry.emit()">
          RETRY
        </button>
        <button type="button" class="secondary-button" (click)="back.emit()">
          BACK
        </button>
      </div>
    </div>
  } @else {
    <div class="target-loading-body" aria-hidden="true">
      <mzic-svg
        class="loading-back-icon"
        src="assets/icons/arrow-left-disabled.svg" />
      <div class="header-skeletons">
        <div class="title-skeleton-row">
          <mzic-skeleton class="title-skeleton" />
        </div>
        <div class="subtitle-skeleton-row">
          <mzic-skeleton class="subtitle-skeleton" />
        </div>
      </div>

      @if (mean === 'CONNECTION') {
        <div class="search-field-skeleton">
          <mzic-skeleton class="search-icon-skeleton" />
          <mzic-skeleton class="search-copy-skeleton" />
        </div>
        <div class="connection-list-skeletons">
          @for (placeholder of placeholders; track placeholder) {
            <div class="connection-card-skeleton">
              <mzic-skeleton class="connection-icon-skeleton" />
              <div class="connection-copy-skeletons">
                <mzic-skeleton class="connection-title-skeleton" />
                <mzic-skeleton class="connection-description-skeleton" />
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="upload-area-skeleton">
          <mzic-skeleton class="upload-icon-skeleton" />
          <mzic-skeleton class="upload-title-skeleton" />
          <mzic-skeleton class="upload-description-skeleton" />
        </div>
        <div class="upload-share-skeleton">
          <mzic-skeleton class="share-copy-skeleton" />
          <mzic-skeleton class="share-action-skeleton" />
        </div>
      }
    </div>

    <div class="target-loading-footer" aria-hidden="true">
      <mzic-skeleton class="action-skeleton" />
    </div>
  }
</section>
